import { render, staticRenderFns } from "./AddStep.vue?vue&type=template&id=0070a620&scoped=true&"
import script from "./AddStep.vue?vue&type=script&lang=js&"
export * from "./AddStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070a620",
  null
  
)

export default component.exports